export const UtiqStatusEntryName = 'utiq_consent_status';

export const UtiqConsentVersionEntryName = 'utiq_consent_version';

export const UtiqConsentVersionPreviousEntryName =
  'utiq_consent_version_previous';

export const ConnectionEligibilityDataEntryName = 'utiqEligibility';

export const UtiqAskMeLater = 'utiq_popup_ask_me_later';

export const UtiqAskMeLaterAndRejected = 'utiq_popup_ask_me_later_and_rejected';

export const IdsSetParam = 'ids_set';

export const IdsNotSetParam = 'ids_not_set';

export const IdsUpdatedParam = 'ids_updated';

export const IdsNotUpdatedParam = 'ids_not_updated';

export const ConsentShownParam = 'consent_shown';

export const UtiqPostConsentInitial = 'utiq_postconsent_initial';

export const UtiqOpenRtbEidsEntryName = 'utiq_openrtb_eids';

export const NetidUtiqAdtechpass = 'netid_utiq_adtechpass';
